import { useScrollRevealGroup } from '../../../hooks/useScrollReveal';

const pillars = [
  { icon: 'ri-code-s-slash-line', label: 'We Design', color: 'text-ds-red' },
  { icon: 'ri-settings-4-line', label: 'We Build', color: 'text-ds-blue' },
  { icon: 'ri-robot-2-line', label: 'We Automate', color: 'text-ds-red' },
  { icon: 'ri-trophy-line', label: 'We Dominate', color: 'text-ds-blue' },
];

export default function AboutSection() {
  const groupRef = useScrollRevealGroup();

  return (
    <section id="about" className="relative pt-24 pb-16 bg-ds-bg overflow-hidden">
      <div className="absolute top-1/2 left-0 w-80 h-80 bg-ds-red/6 blur-[100px] rounded-full pointer-events-none -translate-y-1/2" />

      <div
        className="max-w-7xl mx-auto px-6"
        ref={groupRef}
      >
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left image */}
          <div className="reveal-left relative order-2 lg:order-1">
            <div className="relative overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/fe7da65b3405989566c8d26aee1e61ad.jpg"
                alt="Darkside Digital Team"
                className="w-full h-[480px] lg:h-[600px] object-cover object-top"
                loading="lazy"
                decoding="async"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-ds-bg/60 via-transparent to-transparent" />
              <div className="absolute inset-0 bg-gradient-to-t from-ds-bg/80 via-transparent to-transparent" />
            </div>

            {/* Floating badge */}
            <div
              className="absolute top-8 right-0 bg-ds-bg-2 border border-ds-red/30 px-5 py-4"
              style={{ boxShadow: '0 0 30px rgba(180,255,57,0.15)' }}
            >
              <div className="font-display text-4xl text-ds-red">11+</div>
              <div className="font-body text-white/60 text-xs leading-tight mt-0.5">Years Building<br />Local Weapons</div>
            </div>

            {/* Accent line */}
            <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-ds-red via-ds-red/50 to-transparent" />
          </div>

          {/* Right content */}
          <div className="order-1 lg:order-2">
            <span className="section-label reveal">Who We Are</span>
            <div className="flex items-center gap-3 mb-4 reveal">
              <span className="font-body text-white/30 text-xs tracking-[0.3em] uppercase border border-ds-border px-3 py-1">11+ Years</span>
              <div className="h-px flex-1 bg-ds-border" />
            </div>
            <h2 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-white leading-none mb-8 reveal">
              WE&apos;RE NOT YOUR
              <br />
              <span className="text-ds-red neon-text-red">AVERAGE</span>
              <br />
              WEB AGENCY.
            </h2>

            <div className="space-y-5 mb-10">
              {[
                "Founded in 2015, Darkside Digital was built for one reason — to give local businesses the tools, technology, and strategy that was once only available to big corporations.",
                "Based in Mission Beach, Far North Queensland — and we know what it takes to compete in regional and local Australian markets where big-city agencies don't bother showing up.",
                "We combine cutting-edge website design with real AI implementation. That means smarter automation, stronger online presence, and a business that works harder even when you're not.",
                "We don't do cookie-cutter. We don't do average. We build weapons.",
              ].map((para, i) => (
                <p
                  key={i}
                  className={`font-body text-white/60 text-base leading-relaxed reveal ${i === 3 ? 'text-white/80 font-600' : ''}`}
                  style={{ transitionDelay: `${i * 80}ms` }}
                >
                  {para}
                </p>
              ))}
            </div>

            {/* Pillars */}
            <div className="grid grid-cols-2 gap-3 reveal">
              {pillars.map((p) => (
                <div
                  key={p.label}
                  className="flex items-center gap-3 bg-ds-bg-2 border border-ds-border px-4 py-3"
                >
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className={`${p.icon} ${p.color} text-lg`} />
                  </div>
                  <span className="font-heading font-700 text-white text-sm tracking-wide">{p.label}</span>
                </div>
              ))}
            </div>

            {/* Who we help */}
            <div className="mt-8 p-6 border border-ds-border bg-ds-bg-2 reveal">
              <p className="font-body text-white/40 text-xs tracking-widest uppercase mb-3">We Help</p>
              <div className="flex flex-wrap gap-2">
                {['Trades', 'Hospitality', 'Retail', 'Health & Wellness', 'Professional Services', 'Tourism'].map((tag) => (
                  <span
                    key={tag}
                    className="font-body text-xs text-white/60 border border-ds-border px-3 py-1 hover:border-ds-red/50 hover:text-white transition-colors duration-200 cursor-default"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
